<section class="relative" [cdkMenuTriggerFor]="disabled() || readonly() ? null : c">
    <app-input
        [color]="currentColor()"
        [size]="currentSize()"
        [rounded]="currentRounded()"
        [required]="required()"
        [readonly]="readonly()"
        [disabled]="disabled()"
        [autofocus]="autofocus()"
        [autocomplete]="autocomplete()"
        [spellcheck]="spellcheck()"
        [label]="label()"
        [(value)]="inputValue"
        [placeholder]="placeholder()"
        (valueChange)="handleInput($event)"
        (inputKeydown)="handleKeyDown($event)"
    >
        <app-icon
            (click)="handleOpenCalendar()"
            [attr.data-theme]="theme()"
            class="cursor-pointer theme-text"
            size="sm"
            icons
            [name]="icon() || 'solar:calendar-bold-duotone'"
        />
    </app-input>
</section>

<ng-template #c>
    <div
        cdkMenu
        class="flex items-center w-screen h-screen p-4 shadow-md -0 md:min-w-max md:inset-auto md:w-auto md:h-auto md:p-0 md:bg-transparent bg-black/70"
    >
        <app-input-calendar [attr.data-theme]="theme()" [date]="date()" (select)="handleSelect($event)" />
    </div>
</ng-template>
